import React from 'react';
import './index.css';

interface FadeTransitionProps {
  children: React.ReactNode;
}

function FadeTransition({ children }: FadeTransitionProps) {
  return (
    <div className="fade-wrapper">
      {children}
    </div>
  );
}

export default FadeTransition;